// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { reduxForm } from 'redux-form'
import { Search } from './components'
import { SubmitErrors } from 'components/Form'
import { pathDatabaseSearchValidate } from 'validators/databaseSearches'
import {
  AdvancedSearchWrapper,
  Pagination,
} from '../common'

const {
  asyncValidate,
  validate,
} = pathDatabaseSearchValidate

const Form = ({ change, error, form, handleSubmit, hasResults }) => (
  <form
    className={'path-database-search-form heading-font'}
    id={form}
    onSubmit={handleSubmit}>
    <SubmitErrors
      error={error}
      idRoot={form}
      sourceForm={form} />
    <AdvancedSearchWrapper
      AdvancedSearch={Search}
      change={change}
      hasResults={hasResults}
      idRoot={`${form}-`}
      sourceForm={form} />
    <Pagination
      idRoot={`${form}-`}
      sourceForm={form} />
  </form>
)

Form.propTypes = {
  change: func.isRequired,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  hasResults: bool.isRequired,
  error: string,
}

export default reduxForm({
  asyncBlurFields: [
    'antennaCode',
    'radioCode',
  ],
  asyncValidate,
  destroyOnUnmount: false, // allows for previous form values to persist
  validate,
})(Form)
